/*
 * File: /apps/web/src/build/redux/modules/pageNavigationHelper.js
 * Project: tr-web
 * Created Date: 2020-02-05
 * Author: Raif
 *
 * Copyright (c) 2020 TaskRabbit, Inc
 */
import { scheduleValid } from "build/redux/modules/managerUtil";
import { pick } from "lodash";
import { getCookie } from "util/cookie";
import { generateFunnelId } from "util/generateFunnelId";
import qs from "qs";

const REQUIRED_PARAM_REGEX =
  /^(utm_.+|gclid|signup_success|newAuthProvider|source|uuid|ref|_ab|_cf|job_draft_guid|job_draft_source|guid|funnel_id|tid|rabbit_ids|page_number)$/;

export const validateConfirmState = (job) => {
  const {
    invitee_id: inviteeId,
    schedule,
    taskTemplate: { skip_recommendations: skipRecommendations },
  } = job;
  return (skipRecommendations || inviteeId) && scheduleValid(schedule);
};

export const determineNextValidPageToVisit = (job, pages, loggedIn) => {
  const {
    uuid,
    invitee_id: inviteeId,
    taskTemplate: { is_ikea: isIkea },
  } = job;

  // // this is some very difficult to follow logic but I believe it is as clean as I can make it
  let page = "recommendations";

  if (validateConfirmState(job) && loggedIn) {
    page = "confirm";
  } else if (inviteeId && isIkea) {
    page = "form";
  } else if (inviteeId) {
    page = "hire";
  }

  return {
    pathname: page,
    search: `?uuid=${uuid}`,
  };
};

export const cleanUpUrl = (state) => {
  const { job } = state.build.manager;
  const { pages } = state.build.progress;
  const { loggedIn } = state.user;

  const params = { ...state.build.manager.query };
  const uid = getCookie("uid") || "unknown-guid";

  params.funnel_id = params.funnel_id
    ? params.funnel_id
    : generateFunnelId(
        uid,
        job.isRescue ? "tasker_replacement" : undefined,
        job.category_id
      );

  const keeps = Object.keys(params).filter((p) => REQUIRED_PARAM_REGEX.test(p));
  const { uuid } = state.build.manager.job;
  let { page } = state.build.progress;
  const kept = pick(params, keeps);
  // add v3 query param to pin users to v3 flow (instead of Nextjs) if they refresh the form page
  const query = qs.stringify({ ...kept, uuid, v3: true });

  if (page === "draft") {
    return determineNextValidPageToVisit(job, pages, loggedIn);
  }

  if (page === "repost" && state.build.repost.jobRepostData.page) {
    page = state.build.repost.jobRepostData.page;
  }

  return page + "?" + query;
};
